<!-- Header -->
<header>
  <div class="header-container">
    <img class="logo" src="assets/images/lex-z_logo.png" alt="Lex-Z" />

    <nav>
      <a href="https://lex-z.ai/">Find Lawyers</a>
      <a href="https://lex-z.ai/video-consultation/">Video Consultation</a>
      <a href="https://lex-z.ai/credential-validation/">Credential Validation</a>
      <a href="https://lex-z.ai/products/">Products</a>
      <a href="https://lex-z.ai/blogs/">Resources</a>
      <!-- Show avatar if logged in, else show Login/Signup -->
      <ng-container *ngIf="isLoggedIn; else loginBtn">
        <a href="javascript:void(0)" class="my-appointments-btn" (click)="router.navigate(['/consumer/appointments'])">
          My Appointments
        </a>
      </ng-container>
      <ng-template #loginBtn>
        <a href="javascript:void(0)" class="login-signup-btn" (click)="login()">Login / Signup</a>
      </ng-template>
    </nav>

    <button class="mobile-menu-btn" (click)="toggleMobileMenu()">☰</button>
  </div>

  <div class="mobile-menu" [class.active]="mobileMenuOpen">
    <div class="header-container">
      <div style="width: 100%;">
        <nav class="mobile-nav">
          <a href="https://lex-z.ai/">Find Lawyers</a>
          <a href="https://lex-z.ai/video-consultation/">Video Consultation</a>
          <a href="https://lex-z.ai/credential-validation/">Credential Validation</a>
          <a href="https://lex-z.ai/products/">Products</a>
          <a href="https://lex-z.ai/blogs/">Resources</a>
          <ng-container *ngIf="isLoggedIn; else mobileLoginBtn">
            <a href="javascript:void(0)" class="my-appointments-btn"
               (click)="mobileMenuOpen = false; router.navigate(['/consumer/appointments'])">
              My Appointments
            </a>
          </ng-container>
          <ng-template #mobileLoginBtn>
            <a href="javascript:void(0)" class="login-signup-btn"
               (click)="mobileMenuOpen = false; login()">Login / Signup</a>
          </ng-template>
        </nav>
      </div>
    </div>
  </div>
</header>

<!-- Hero Section -->
<section class="hero">
  <div class="hero-content">
    <h1>
      Find Trusted
      <span class="highlight">
        Lawyers
        <svg class="underline" viewBox="0 0 200 12">
          <path d="M2 10C50 2 150 2 198 10"></path>
        </svg>
      </span>
      Near You
    </h1>
    <p>
      Search, compare, and book appointments with verified legal professionals.
      Get expert legal advice from India's top-rated lawyers.
    </p>

    <div class="search-container">
      <form class="search-form" (ngSubmit)="onSearch()">
        <div class="search-input-wrapper">
          <svg class="input-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
          </svg>
          <input type="text" class="search-input" [placeholder]="isDetectingLocation ? 'Detecting location...' : 'Current Location'" [(ngModel)]="search.location" name="location">
          <span
          class="clear-input"
          *ngIf="search.location"
          (click)="clearLocation()">
          ✕
        </span>

        </div>
          <div class="search-input-wrapper" style="padding-left: 0; position: relative;">
    
    <input 
      type="text" 
      class="search-input" 
      placeholder="Divorce law, Property law"
      [(ngModel)]="search.service" 
      name="service" 
      style="padding-left: 1rem;"
      (focus)="onServiceFocus()"
      (input)="onServiceInput($event)"
      (blur)="onServiceBlur()"
      autocomplete="off">

    <!-- Dropdown -->
    <div 
      class="specialization-dropdown" 
      *ngIf="showSpecializationDropdown">

      <div 
        class="specialization-item" 
        *ngFor="let spec of filteredSpecializations"
        (mousedown)="selectSpecialization(spec)"> <!-- ✅ changed from click to mousedown -->

        <i class="fas fa-search search-icon"></i>
        <div class="spec-content">
          <span class="spec-name">{{ spec.name }}</span>
          <span class="spec-type">{{ spec.type }}</span>
        </div>
      </div>

      <!-- Show no results message -->
      <div class="specialization-item no-results"
          *ngIf="filteredSpecializations.length === 0">
        No results found
      </div>

    </div>

    <span
      class="clear-input"
      *ngIf="search.service"
      (click)="clearService()">
      ✕
    </span>

  </div>
        <button type="submit" class="search-btn" (click)="onSearch()">
          <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
          <span>Search Lawyers</span>
        </button>
      </form>

      <div class="popular-searches">
        <p class="popular-searches-label">Popular Searches:</p>
        <div class="search-tags">
          <button class="search-tag" *ngFor="let tag of popularSearches" (click)="selectPopular(tag)">
            {{ tag }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Feature Cards -->
<section class="features-section">
  <div class="features-container">
    <div class="feature-card">
      <div class="feature-icon">
        <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path>
        </svg>
      </div>
      <h3>Find Lawyers</h3>
      <p>Search and connect with verified legal professionals across India for your specific legal needs.</p>
      <button class="feature-btn" (click)="scrollToTop()">Learn More</button>
    </div>

    <div class="feature-card">
      <div class="feature-icon">
        <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
        </svg>
      </div>
      <h3>Instant Video Consultation</h3>
      <p>Book online video consultations with expert lawyers from the comfort of your home.</p>
      <button class="feature-btn" (click)="gotoVideoConsult()">Learn More</button>
    </div>

    <div class="feature-card">
      <div class="feature-icon">
        <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
        </svg>
      </div>
      <h3>Legal Credentials</h3>
      <p>Verify credentials and track records of lawyers to make informed decisions.</p>
      <button class="feature-btn" (click)="gotoLegalVerification()">Learn More</button>
    </div>
  </div>
</section>

<!-- Lawyer CTA -->
<section class="lawyer-cta">
  <div class="lawyer-cta-content">
    <h2>Are You a Lawyer?</h2>
    <p>Join our platform and connect with clients across India. Grow your practice with our verified lawyer network.</p>
    <button class="lawyer-cta-btn" (click)="goToLawyerRegister()">
      Register Now
    </button>
  </div>
</section>

<!-- Footer -->
<footer>
  <div class="footer-container">
    <!-- <div class="footer-grid">

      <div class="footer-column">
        <div class="footer-logo">
          <svg class="footer-logo-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path>
          </svg>
          <span class="footer-logo-text">Lex-Z</span>
        </div>
        <p>Lex-Z - India's most trusted platform for connecting clients with qualified legal professionals. Get expert legal advice from verified lawyers across all practice areas.</p>
      </div>

      <div class="footer-column">
        <h4>Quick Links</h4>
        <ul>
          <li><a href="/">Home</a></li>
          <li><a href="#">About</a></li>
          <li><a href="#">Careers</a></li>
          <li><a href="#">Contact Us</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h4>Legal Services</h4>
        <ul>
          <li><a href="#">Family Law</a></li>
          <li><a href="#">Criminal Law</a></li>
          <li><a href="#">Corporate Law</a></li>
          <li><a href="#">Property Law</a></li>
          <li><a href="#">Tax Law</a></li>
          <li><a href="#">Cyber Law</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h4>Contact Info</h4>
        <ul>
          <li><a href="tel:+919876543210"><i class="bi bi-telephone-fill"></i> +91 98765 43210</a></li>
          <li><a href="mailto:support@lexiz.ai"><i class="bi bi-envelope-fill"></i> support@lexiz.ai</a></li>
          <li><a href="#"><i class="bi bi-geo-alt-fill"></i> 123 Legal Plaza, Connaught Place, New Delhi - 110001</a></li>
        </ul>

        <div class="newsletter">
          <h4>Newsletter</h4>
          <div class="newsletter-box">
            <input type="email" placeholder="Enter your email">
            <button>➤</button>
          </div>
        </div>
      </div>

    </div> -->

    <div class="footer-bottom">
      <a  alt="terms of service"
            href="https://digicoffer.com/digicoffer_terms.pdf">Terms of Service</a>
      <span>|</span>
      <a alt="privacy policy" href="https://digicoffer.com/digicoffer_privacy.pdf">Privacy Policy</a>
      <span>|</span>
      <a href="https://digicoffer.com/digicoffer_cookie.pdf">Cookie Policy</a>
    </div>

    <div class="footer-credit">
      © {{ currentYear }} Lex-Z. All rights reserved.
    </div>
  </div>
</footer>